// main.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <style>
      {`
        @font-face {
          font-family: 'Starim';
          src: url('/fonts/Starbim/Starbim.ttf') format('truetype');
          font-weight: 400;
          font-style: normal;
          font-display: swap;
        }
      `}
    </style>
    <App />
  </React.StrictMode>
);
